import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { cascadestore, cascadeedit, cascadedelete, cascadelist } from '../request';
export default {
  props: {
    index: {
      type: Number // 传过来index作为唯一index作为标识
    },
    formDataArray: {
      type: Array
    },
    itemmark: {
      type: String
    }
  },
  data() {
    return {
      currentOptions: [],
      treeData: [],
      dialogVisible: false,
      maxLevel: 6,
      idx: 0,
      treeRow: null,
      form: {
        name: '',
        value: ''
      },
      formRules: {
        name: [{
          required: true,
          message: this.$t('请输入字典值'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 30,
          message: this.$t('长度在 1 到 30 个字符'),
          trigger: 'blur'
        }, {
          validator: this.checkDuplicateName,
          trigger: 'blur'
        }],
        value: [{
          min: 1,
          max: 50,
          message: this.$t('长度在 1 到 50 个字符'),
          trigger: 'blur'
        }
        // 其他的验证规则
        ]
      }
    };
  },
  created() {},
  mounted() {
    this.GETcascadelist(); // 自定义列表接口数据
  },
  computed: {
    controlMark() {
      return this.formDataArray[this.index].mark;
    },
    indexID() {
      return this.index;
    }
  },
  methods: {
    // 检查是否有重复的值
    checkDuplicateName(rule, value, callback) {
      const duplicateItem = this.treeData.find(item => item.name === value);
      if (duplicateItem) {
        callback(new Error(this.$t('字典值已存在，请输入不重复的字典值')));
      } else {
        callback();
      }
    },
    // 指标是
    generateValue() {
      const time = new Date().getTime();
      const timestamp = String(time).slice(-4); // 使用时间戳的后四位作为值标识
      return timestamp;
    },
    // 自定义列表---------------------------------------------------------------------------
    async GETcascadelist() {
      let currentOptions = await cascadelist({
        type: 'CUSTOM',
        controlMark: this.controlMark,
        // 层级值标识
        is_hierarchy: false
      });
      this.treeData = [{
        name: this.$t('全部数据'),
        id: 0,
        value: '',
        pId: 0,
        level: 0,
        children: []
      }, ...currentOptions];

      // 将数据传给下拉框
      this.formDataArray[this.indexID].Customvalues = currentOptions;
      this.$emit('tree-list', this.formDataArray[this.indexID].Customvalues);
    },
    // 在这里面添加              {$t('添加')} 报错
    renderContent(h, {
      node,
      data
    }) {
      console.log(node.data, data, '===node.data');
      return h("span", {
        "style": "font-size: 15px;height:50px;line-height: 50px;"
      }, [h("span", {
        "style": "margin-right:50px;"
      }, [h("span", [this.$t('字典值'), "\uFF1A ", data.name])]), h("span", [h("span", [this.$t('值标识'), "\uFF1A", data.mark || ''])]), h("span", {
        "style": "margin-left:100px;"
      }, [h("el-button", {
        "attrs": {
          "type": "text",
          "icon": "el-icon-plus"
        },
        "on": {
          "click": () => this.addItem(node, false)
        },
        "directives": [{
          name: "show",
          value: node.level < this.maxLevel
        }]
      }, [this.$t('添加')]), h("el-button", {
        "attrs": {
          "type": "text",
          "icon": "el-icon-edit"
        },
        "directives": [{
          name: "show",
          value: data.id !== 0
        }],
        "on": {
          "click": () => this.editItem(node, true)
        }
      }, [this.$t('编辑')]), h("el-button", {
        "attrs": {
          "type": "text",
          "icon": "el-icon-delete"
        },
        "directives": [{
          name: "show",
          value: data.id !== 0
        }],
        "on": {
          "click": () => this.removeItem(node)
        }
      }, [this.$t('删除')])])]);
    },
    // 追加
    addItem(node, flag) {
      this.dialogVisible = true;
      this.$refs.form && this.$refs.form.clearValidate();
      this.treeRow = {
        isEdit: flag,
        level: node.level,
        ...node.data
      };
      this.form = {
        name: '',
        // 名字
        value: '' // 标识
      };
    },
    editItem(node, flag) {
      this.dialogVisible = true;
      this.$refs.form && this.$refs.form.clearValidate();
      this.treeRow = {
        isEdit: flag,
        level: node.level,
        ...node.data
      };
      this.form = {
        name: node.data.name,
        // 名字
        value: node.data.mark // 标识
      };
    },
    saveItem() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.form.value) {
            // 生成系统自动的值标识
            const generatedValue = this.generateValue();
            this.form.value = generatedValue;
          }
          // 执行保存操作
          // ...
        } else {
          // 表单验证不通过的处理逻辑
        }
      });
    },
    saveItem() {
      // type 是 string CUSTOM自定义
      // name 是 int 层级名称
      // mark 是 int 层级值标识
      // controlMark 是 int 控件标识
      // level 是 int 层级 例子：1、2、3、4、5最多5级
      // pId 是 int 父级ID （一级默认为0）
      console.log(this.treeRow, 'dadawda');
      this.$refs.form.validate(valid => {
        if (valid) {
          // 新加指标是 自动添加
          if (!this.form.value) {
            // 生成系统自动的值标识
            const generatedValue = this.generateValue();
            this.form.value = generatedValue;
          }
          if (this.treeRow.isEdit) {
            let editQuery = {
              type: 'CUSTOM',
              name: this.form.name,
              mark: this.form.value,
              controlMark: this.controlMark,
              // 层级值标识
              cascadeId: this.treeRow.id
            };
            cascadeedit(editQuery).then(res => {
              this.dialogVisible = false;
              this.GETcascadelist(); //更新列表数据;
            });
          } else {
            let query = {
              type: 'CUSTOM',
              // CUSTOM自定义
              name: this.form.name,
              // 层级名称
              controlMark: this.controlMark,
              // 层级值标识
              level: this.treeRow.level + 1,
              // 层级 例子：1、2、3、4、5最多5级
              mark: this.form.value,
              // 控件标识
              pId: this.treeRow.id // 父级ID （一级默认为0）
            };
            cascadestore(query).then(res => {
              this.dialogVisible = false;
              this.GETcascadelist(); //更新列表数据;
            });
          }
        }
      });
    },
    // 删除  不用操作节点直接删
    removeItem(nodes) {
      cascadedelete({
        cascadeId: nodes.data.id //层级 （自定义ID）
      }).then(res => {
        this.GETcascadelist(); //更新列表数据
      });
    }
  }
};